const moment = require('moment');
import { IGoal } from 'motw_core/Entity/IGoal';
import { IGoalWithDatapoints } from 'motw_core/Repositories/DatapointRepository';
import { GEPNameProperty, GoalEditorPanel } from './GoalEditorPanel';

export function HandleValueChange(
	GEP: GoalEditorPanel,
	newValue: any,
	property: keyof IGoal
) {
	if (!GEP.state.currentState.hasOwnProperty(property)) {
		throw new Error(
			`The property ${String(property)} does not exist in state`
		);
	}

	const newGEPState = {
		currentState: {
			...GEP.state.currentState,
			[property]: newValue
		}
	};

	const hasGoalNameChanged = String(property) === GEPNameProperty;
	if (hasGoalNameChanged) {
		ResetGoal(newGEPState.currentState);
	}

	GEP.setState(newGEPState);
}

function ResetGoal(newGEPState: IGoalWithDatapoints) {
	newGEPState.startdate = moment().local().format('YYYY-MM-DD');
	newGEPState.weeklyrate = 1;
}
